
import sha256 from "js-sha256"
import moment from "moment"
import config from "../config"
import { uuid } from "vue-uuid";

const pako = require('pako');

function is_test()
{
	return config.is_test
}

function get_session()
{
	return window.localStorage.getItem("session")
}

function get_procedure()
{
	return window.sessionStorage.getItem("procedure")
}

function has_oks()
{
	const value = window.localStorage.getItem(storage.procedure_name("has_oks")) === "true"

	return value
}

async function load_roles(self, force = false)
{
	const session = get_session(self)
	var roles

	if(session == "amv" || session == "gvv" || session == "suv" || session == "pdi")
		roles = [ "readonly", "group_tree", "grouping", "model", "cost" ]
	else if(session == "kia")
		roles = [ "readonly", "group_tree", "grouping", "model", "cost" ]
	else if(session == "sei")
		roles = [ "group_tree", "grouping" ]
	else if(session == "kov")
		roles = [ "model", "cost" ]
	else if(session == "kmd")
		roles = [ "grouping" ]
	else if(session == "anv")
		roles = [ "group_tree" ]
	else if(session == "bey")
		roles = [ "readonly" ]
	else if(session == "tlv")
		roles = [ "readonly", "group_tree", "grouping", "model", "cost" ]
	else if(session == "sog")
		roles = [ "readonly", "group_tree", "grouping", "model", "cost" ]

	// TODO 4292
	if (window.localStorage.getItem("readonly") === "true")
	{
		window.localStorage.setItem("roles", [ "readonly" ])
		roles = [ "readonly"]
	}
	else if(roles == null)
	{
		roles = window.localStorage.getItem("roles")

		if(roles == null || force)
			return call(self, "system", "get_roles", {},
				response =>
				{
					roles = response.roles

					window.localStorage.setItem("roles", roles)
				})
	}
	else
		window.localStorage.setItem("roles", roles)
}

function check_roles(self, necessary_roles)
{
	const roles = window.localStorage.getItem("roles")
	
	for(let ind in necessary_roles)
		if(roles.includes(necessary_roles[ind]))
			return true

	return false
}

function default_error_func(self, response)
{
	if(response.exception == "OperationIsCanceled" || response.exception == "ValidationError")
		return

	return show_error_box(self, response)
}

function backend_socket()
{
	const url = config.backend.main_url.replace("CURRENT_HOST", window.location.hostname)

	var socket = new WebSocket(url)

	return socket
}

function base_call(self, service, command, params, success_func, error_func = default_error_func)
{
	return new Promise(
		( resolve, reject ) =>
		{
			let socket = backend_socket()

			socket.onopen = () => socket.send(JSON.stringify({ service : service, command : command, params : params }))

			socket.onmessage =
				event =>
					event.data.arrayBuffer().then(
						raw =>
						{
							const decompress = pako.inflate(raw, { to : "string" })
							var response

							try
							{
								response = JSON.parse(decompress)

								if (response.is_error)
									reject(response)
							}
							catch (exp)
							{
								console.log("Problem with JSON parse", decompress, raw)

								response = { is_error : true } 
							}

							resolve(response)

							socket.close()
						})
		}
	)
	.then(response =>
		{
			// console.log(service, command, params, response)

			success_func(response)
		},
		response =>
		{
			console.log(service, command, params, response)

			error_func(self, response)
		})
}

function call(self, service, command, params, success_func, error_func = default_error_func)
{
	params.session = get_session(self)
	params.procedure = get_procedure(self)

	return base_call(self, service, command, params, success_func, error_func)
}

async function call_without_component(self, service, command, params)
{
	let socket = backend_socket()
	let response

	socket.onmessage =
		event =>
			event.data.arrayBuffer().then(
				raw =>
				{
					const decompress = pako.inflate(raw, { to : "string" })
					
					response = JSON.parse(decompress)

					socket.close()
				})

	params.session = get_session(self)
	params.procedure = get_procedure(self)
	socket.onopen = () => socket.send(JSON.stringify({ service : service, command : command, params : params }))

	while(socket.readyState != 3)
		await new Promise(resolve => setTimeout(resolve, 200))

	return response
}

function call_long_operation(self, msg, service, command, params, success_func, options)
{
	self.$root.$emit("start_long_operation")

	call(self, service, command, params,
		response =>
		{
			success_func(response)

			self.$root.$emit("stop_long_operation")

			if (options && options.success_msg)
			{
				show_notification(self, options.success_msg)
			}
			else
			{
				show_notification(self, "Операция завершена")
			}
		},
		response =>
		{
			if (options && options.error_func)
			{
				options.error_func(self, response)
			}
			else
			{
				default_error_func(self, response)
			}

			self.$root.$emit("stop_long_operation")
		})
}

function file_url(url)
{
	if(url.includes("http"))
		return url

	const hostname = config.backend.url == null ? window.location.hostname : config.backend.url

	return `http://${hostname}:${config.backend.file_port}${url}`
}

function open_response_url(response)
{
	if(response.url != null)
	{
		if(response.url.includes("nspd"))
			download_file(response)
		else
			window.open(file_url(response.url), "_blank")
	}
}

function download_file(response)
{
	if(response.url != null)
	{
		const url = response.url

		if(url.includes("nspd"))
		{
			const fields = url.split("/")
			const fname = fields[fields.length - 1]
			const prepared_url = url.slice(0, url.lastIndexOf("/"))
			const params = { url : prepared_url }
			const backend_url = config.backend.rest_url.replace("CURRENT_HOST", window.location.hostname) + "/download"
			const setups =
			{
				method : "POST",
				body : JSON.stringify(params),
				headers :
				{
					"Content-Type": "application/json",
				}
			}

			fetch(backend_url, setups).then(
				response =>
					response.blob().then(
						blob =>
						{
							const new_blob = new Blob([ blob ])
							const blob_url = window.URL.createObjectURL(new_blob)
							const link = document.createElement("a")

							link.href = blob_url
							link.setAttribute("download", fname)
							document.body.appendChild(link)
							link.click()
							link.parentNode.removeChild(link)

							window.URL.revokeObjectURL(blob_url)
						})
				)
		}
		else
			window.open(file_url(response.url), "_blank")
	}
}

function get_file_extension(fname)
{
	const dot_ind = fname.lastIndexOf(".")

	if(dot_ind > 0)
		return fname.substring(dot_ind + 1)

	return ""
}

// Загрузка файла
//
// fl - описатель файла, возвращаемый FileReader'ом
// fname - имя файла
// name - название файла в системе (к нему будет добавлено расширение из fname, если оно есть у fname)
//
function upload_file(self, fl, fname, name, success_func, error_func = default_error_func)
{
	const data = fl.target.result
	const data_base64 = window.btoa(data)
	const ext = get_file_extension(fname)

	if(get_file_extension(name) == "" && ext != "")
		name = name + "." + ext

	const params =
	{
		data :
		{
			name : name,
			data : data_base64,
			compression : "nothing",
		}
	}

	return call(self, "files", "add", params, success_func, error_func)
}

function delete_file(self, id)
{
	return call(self, "files", "delete", { id : id }, () => {})
}

function show_notification(self, message, timeout = true, auto_hide_delay = 5000)
{
	const h = self.$createElement
						
	const id = `notification_${uuid.v1()}`

	const $toast_content = h(
		'div',
		{
			class: 'ntf_body'
		},
		[
			h(
				'div',
				{
					class: 'ntf_msg'
				},
				message
			),
			h(
				'button',
				{
					on: { click: () => self.$bvToast.hide(id) },
					class : "ntf_close-btn"
				}
			),
		]
	)

	// Create the toast
	self.$bvToast.toast([$toast_content], {
		id: id,
		noCloseButton: true,
		noAutoHide : !timeout,
		autoHideDelay : auto_hide_delay,
		toaster : 'fs-ntf',
		toastClass: "ntf",
	})
}

function show_error_box(self, err, message = null, autohide = false, auto_hide_delay = 5000)
{
	if(message == null)
		message = err.description

	const h = self.$createElement
	var prepared_message = message
	var content = null

	if(err.details && err.details.connected_objects)
	{
		content = [ message ]

		if(err.details.connected_objects.length)
			content.push(h("br"))

		err.details.connected_objects.forEach(
			obj =>
			{
				content.push(h("br"))
				content.push(obj.essence + ": ")
				content.push(h("router-link", { props : { to : "/" + obj.url + "/" + obj.id } }, [ obj.name ]))
			})

		prepared_message = h("p", {}, content)
	}

	if(err.details && ( err.details.attr_names_not_found || err.details.problems ))
	{
		content = [ message ]

		if(err.details.attr_names_not_found)
		{
			if(err.details.attr_names_not_found.length)
				content.push(h("br"))

			err.details.attr_names_not_found.forEach(
				obj =>
				{
					content.push(h("br"))
					content.push(obj)
				})
		}

		if(err.details.problems)
		{
			if(err.details.problems.length)
				content.push(h("br"))

			err.details.problems.forEach(
				obj =>
				{
					content.push(h("br"))
					content.push(obj)
				})
		}

		prepared_message = h("p", {}, content)
	}

	if(err.details && err.details.wait_time)
	{
		content =
		[
			h("center", {}, message),
			h("br"),
			h("center", {}, "Сервис будет доступен через:"),
			h("br"),
			h("center", {}, [ h("h3", {}, err.details.wait_time) ]),
		]

		prepared_message = h("p", {}, content)
	}

	try
	{
		return show_notification(self, prepared_message, autohide, auto_hide_delay)
	}
	catch (exp)
	{
		console.log("Exception in show_error_box", exp)
	}

	return Promise()
}

function get_tooltip(value, desc, cost)
{
	return `<span><strong>${value}</strong>
		<br>${desc !== "" ? desc + ": " : "" }<strong>${cost}</strong></span>`
}

function date_to_iso(value)
{
	return moment(value).toISOString(true)
}

function local_date_from_iso(value)
{
	const result = moment(value + "Z").format()

	if(result == "Invalid date")
		return null

	return result
}

function format_bool(value, no_text = "Нет", hide_has_no_value = false)
{
	if(typeof value != "boolean")
	{
		if(value == null || value == "")
		{
			if(hide_has_no_value)
				return ""

			return `${no_text} (значение отсутствует)`
		}

		return `${value} (некорректное значение)`
	}

	if(value)
		return "Да"

	return no_text
}

function format_date(value)
{
	try
	{
		var splitter = " "

		if(value.includes("T"))
			splitter = "T"

		var fields = value.split(splitter)
		var date = fields[0]
		var with_dash = date.includes("-")
		splitter = with_dash ? "-" : "."

		fields = fields[0].split(splitter)

		if(fields.length < 3)
			return value

		if(with_dash)
			return fields[2] + "." + fields[1] + "." + fields[0]

		return fields[0] + "." + fields[1] + "." + fields[2]
	}
	// eslint-disable-next-line
	catch {}

	return value
}

function format_time(value)
{
	try
	{
		var splitter = " "

		if(value.includes("T"))
			splitter = "T"

		var fields = value.split(splitter)
		var time = fields[0]

		if(fields.length > 1)
			time = fields[1]

		fields = time.split(":")

		if(fields.length < 2)
			return value

		return fields[0] + ":" + fields[1]
	}
	// eslint-disable-next-line
	catch {}

	return value
}

function format_datetime(value)
{
	try
	{
		var fields = value.split("T")

		if(fields.length == 1)
			return format_date(fields[0])
		else if(fields.length == 2)
		{
			const _value = fields[0] + " " + fields[1]

			var date = format_date(_value)
			var time = format_time(_value)

			if(date && time)
				return date + " " + time
		}
	}
	// eslint-disable-next-line
	catch {}

	return value
}

function format_contact_name(value)
{
	if(value)
	{
		if(value.surname)
			return value.surname + " " + value.name

		return value.short_name + "; ИНН: " + value.inn
	}

	return ""
}

function format_document_name(value)
{
	if(value)
	{
		var response = value.name

		if(value.numbers)
			response += ", № " + value.numbers.number

		if(value.date)
			response += " от " + format_date(value.date.add)
	}

	return response
}

function format_row_index(value)
{
	value -= 1 // Т.к. отображаемая нумерация идет с 0

	const base = Math.floor(value / 26)
	const md = value % 26

	if(base == 0)
		return String.fromCharCode('A'.charCodeAt() + md)

	return String.fromCharCode('A'.charCodeAt() + base - 1) + String.fromCharCode('A'.charCodeAt() + md)
}

function format_cost(value, empty_value = "не определен(а)", rub = "руб.")
{
	if(value == null || value == "")
		return empty_value

	var fields = String(round2(value)).split(".")
	const cost_fields = fields[0].split("").reverse().join("").match(/.{1,3}/g)

	fields[0] = cost_fields.join(" ").split("").reverse().join("")

	if(fields.length <= 1)
		return fields[0] + " " + rub

	// Number убирает лидирующие нули
	
	var k = fields[1].slice(0, 2)

	if(k.length == 1)
		k += "0"

	/*
	if(k[0] == "0")
		k = k[1]

	return fields[0] + " руб. " + k + " коп."
	*/

	return `${fields[0]}.${k} ${rub}`
}

function format_reference(ref, value, only_original = false)
{
	if(ref == null)
		return value

	if(ref.original && Object.keys(ref.original).length && ref.original[value] != undefined) // Странно, но вот так
	{
		const original = ref.original[value]

		if(only_original)
			return original

		if(value != original)
			return value + " ( " + ref.original[value] + " ) "
	}

	if(ref.original_detailed)
	{
		const original = ref.original_detailed[value]

		if(original) 
		{
			const using = original.using

			if(using)
			{
				if(only_original)
					return using

				return value + " ( " + using + " ) "
			}
		}
	}

	return value
}

function format_user(value)
{
	var prepared_value = value.login

	if(value.info && value.info.name)
		prepared_value = value.info.name + " ( " + value.login + " )"

	return prepared_value
}

function format_attr_type(value)
{
	const elem = attrs_type_options.find(elem => elem.value == value)

	if(elem == null)
		return ""

	return elem.text
}

function format_key_parameter(elem, ref)
{
	if(elem.Value == null)
		return ""

	if(elem.Type == null)
		return "Значение = " + elem.Value + ", тип не указан"

	return "Значение = " + elem.Value + ", тип = " + format_reference(ref, elem.Type)
}

function format_tick_label(attr, value)
{
	if(attr.type == "number")
		return number_to_string_with_ranking(value)

	return value
}

function is_empty(value)
{
	return value === null || value === "" || value === undefined
}

function format_value_empty(value)
{
	return is_empty(value) ? "<значение отсутствует>" : value
}

// Подготавливает массив словарей для отображения в таблице - для ОО, ОА
function prepare_array_of_objects_for_table(attrs, key)
{
	var value = attrs[key]
	var desc = {}
	var create_desc =
		( obj, desc ) =>
			Object.entries(obj).forEach(
				elem =>
				{
					const elem_key = elem[0]
					const elem_value = elem[1]

					if(! Array.isArray(elem_value) && typeof elem_value == "object" && elem_value != null)
					{
						if(desc[elem_key] == null)
							desc[elem_key] = {}

						create_desc(elem_value, desc[elem_key])
					}
					else if(Array.isArray(elem_value) && elem_value.length && typeof elem_value[0] == "object")
					{
						if(desc[elem_key] == null)
							desc[elem_key] = {}

						elem_value.forEach(sub_elem_value => create_desc(sub_elem_value, desc[elem_key]))
					}
					else
					{
						if(desc[elem_key] == null)
							desc[elem_key] = []

						desc[elem_key].push(elem_value)
					}
				})

	if(Array.isArray(value))
	{
		value.forEach(sub_value => create_desc(sub_value, desc))
	}
	else
		create_desc(value, desc)

	return desc
}

function sort_strings(arr, is_desc = false)
{
	if(is_desc)
		return arr.sort(
		( a, b ) =>
		{
			if(a > b) return -1
			if(a < b) return 1

			return 0
		})
	else
		return arr.sort(
		( a, b ) =>
		{
			if(a < b) return -1
			if(a > b) return 1

			return 0
		})
}

function sort_objects_array_by_key(arr, key, is_desc = false)
{
	if(is_desc)
		return arr.sort(
		( a, b ) =>
		{
			if (a[key] > b[key]) return -1
			if (a[key] < b[key]) return 1

			return 0
		})
	else
		return arr.sort(
		( a, b ) =>
		{
			if (a[key] < b[key]) return -1
			if (a[key] > b[key]) return 1

			return 0
		})
}

function sort_objects_array_by_two_keys(arr, key, nested_key, is_desc = false)
{
	if(is_desc)
		return arr.sort(
		( a, b ) =>
		{
			if ( ( a[key] == null && b[key] != null ) || ( a[key][nested_key] < b[key][nested_key] )) return 1
			if ( ( a[key] != null && b[key] == null ) || ( a[key][nested_key] > b[key][nested_key] )) return -1

			return 0
		})
	else
		return arr.sort(
		( a, b ) =>
		{
			if ( ( a[key] == null && b[key] != null ) || ( a[key][nested_key] < b[key][nested_key] )) return -1
			if ( ( a[key] != null && b[key] == null ) || ( a[key][nested_key] > b[key][nested_key] )) return 1

			return 0
		})
}

function sort_objects_array_by_many_keys(arr, keys, is_desc = false)
{
	if(is_desc)
		return arr.sort(
		( a, b ) =>
		{
			for ( const key of keys )
			{
				if (a[key] > b[key]) return -1
				if (a[key] < b[key]) return 1
			}

			return 0
		})
	else
		return arr.sort(
		( a, b ) =>
		{
			for ( const key of keys )
			{
				if (a[key] < b[key]) return -1
				if (a[key] > b[key]) return 1
			}

			return 0
		})
}

function sort_objects_array_with_key_func(arr, func, is_desc = false)
{
	if(is_desc)
		return arr.sort(
		( a, b ) =>
		{
			const a_value = func(a)
			const b_value = func(b)

			if (a_value > b_value) return -1
			if (a_value < b_value) return 1

			return 0
		})
	else
		return arr.sort(
		( a, b ) =>
		{
			const a_value = func(a)
			const b_value = func(b)

			if (a_value < b_value) return -1
			if (a_value > b_value) return 1

			return 0
		})
}

function sort_attrs_visible(attrs_visible)
{
	return attrs_visible.sort(
		( a, b ) =>
		{
			if ( a.last && b.last )
				return 0
			else if ( b.last )
				return -1
			else if ( a.last )
				return 1
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort 
			else if ( a.position && b.position )
				return a.position - b.position
			else if ( a.position )
				return 1
			else if ( b.position )
				return -1

			return 0
		})
}

function get_obj_value(obj, key, fields = null)
{
	var next_obj = obj
	var index

	if(fields == null)
		fields = key.split(".")

	for(index in fields)
	{
		const sub_key = fields[index]
		next_obj = next_obj[sub_key]

		if(next_obj == null)
			return null
		else if(next_obj != null && next_obj.constructor === Array)
		{
			var values = []
			var _fields = fields.slice(parseInt(index) + 1)

			next_obj.forEach(_obj => values.push(get_obj_value(_obj, null, _fields)))

			if(values.some(value => value != null))
				return values

			return null
		}
	}

	return next_obj
}

function get_attr_value(attrs, obj, key)
{
	var raw = get_obj_value(obj, key)
	var attr = attrs.find(elem => elem.key == key)

	if(attr == null)
		return raw

	return format_attr_value(attr, raw)
}

function format_attr_value(attr, value, hide_bool_has_no_value = false)
{
	if(attr.type == "bool")
		return format_bool(value, "Нет", hide_bool_has_no_value)
	else if(attr.type == "date")
		return format_date(value)
	else if(attr.type == "time")
		return format_time(value)
	else if(attr.type == "datetime")
		return format_datetime(value)
	else if(attr.reference)
		return format_reference(attr.reference, value)

	return value
}

// Число в строку с делением на разряды
function number_to_string_with_ranking(value)
{
	if(value == null)
		return ""

	var fields = []
	var field = []
	var field_parts = value.toString().split(".")

	field_parts[0].split("").reverse().forEach(
		ch =>
		{
			field.push(ch)

			if(field.length == 3)
			{
				fields.push(field.reverse().join(""))
				field = []
			}
		})

	if(field.length)
		fields.push(field.reverse().join(""))

	var result = fields.reverse().join(" ")

	if(field_parts.length > 1)
		result += "." + field_parts[1]

	return result
}

// #############################################################################
// Форматирование значений для таблиц объектов и для таблиц атрибутов объектов в их карточках

function format_field(value, format_func)
{
	var result = []
	var prepared_value = []

	if(Array.isArray(value))
		prepared_value = value
	else
		prepared_value = [ value ]

	prepared_value.forEach(sub_value => result.push(format_func(sub_value)))

	return result.join("\n")
}

function format_value(value, value_type, reference = null, accuracy = null)
{
	return base_format_value(value_type, null, null, value, reference, accuracy)
}

function format_value_from_data(data, key, value_type, reference = null, accuracy = null)
{
	return base_format_value(value_type, data, key, null, reference, accuracy)
}

function base_format_value(value_type, data = null, key = null, value = null, reference = null, accuracy = null)
{
	if(data != null && key != null)
		value = get_obj_value(data, key)

	if(value_type == "bool")
		return format_field(value, format_bool)
	else if(value_type == "number")
	{
		var format_number = value =>
		{
			if(accuracy != null && ! isNaN(accuracy) && accuracy != "" && typeof value == "number")
				return value.toFixed(accuracy)

			return value
		}

		return format_field(value, format_number)
	}
	else if(value_type == "date")
		return format_field(value, format_date)
	else if(value_type == "datetime")
		return format_field(value, format_datetime)
	else if(value_type == "time")
		return format_field(value, format_time)
	
	// str

	var format_str = value => value

	if(reference != null)
		format_str = value => format_reference(reference, value)

	return format_field(value, format_str)
}

// #############################################################################

function deep_clone(obj)
{
	return JSON.parse(JSON.stringify(obj))
}

function get_address_of_cadastral_object(obj)
{
	var value

	if(obj.current_version)
	{
		const attrs = obj.current_version.attrs

		if(attrs.Location != null)
		{
			if(attrs.Location.Address != null && attrs.Location.Address.Note != null)
				value = attrs.Location.Address.Note
			else
				value = attrs.Location.Note

			// TODO Грязный хак - то ли база плохая была 09.12.2022 на тесте, то ли ошибка где есть
			if(value == "None")
				value = null
		}
	}

	return null
}

function format_coinvest_cost_per_unit(attrs)
{
	const cost = attrs.coinvest_cost

	if(cost == null)
		return null

	/*
	const unit = attrs.coinvest_unit
	const area = attrs.Area
	const volume = attrs.coinvest_volume
	const volume_by_documents = attrs.volume_by_documents
	*/
	const dimension = attrs.coinvest_dimension
	var coef = dimension
	var comment = ""

	if(coef == null || coef == 0)
		return null // cost

	// return cost.toString() + " (на единицу измерения: " + (cost / coef).toFixed(2).toString() + comment + ")"
	return "(на единицу измерения: " + (cost / coef).toFixed(2).toString() + comment + ")"
}

function expand_node_in_tree(tree, query, with_children = false, with_select = true, selection = null)
{
	if(selection == null)
		selection = tree.find(query)

	if(selection.length == 0)
		return

	var node = selection[0]
	var parent = node.parent

	if(with_select)
		node.select()

	if(with_children)
		node.expand()

	while (parent != null)
	{
		parent.expand()
		parent = parent.parent
	}

	return node
}

function check_number({ value, accuracy, gte, gt, lt, lte })
{
	if (value === null || value === "" || isNaN(value))
	{
		return false
	}

	if (accuracy !== undefined)
	{
		const str = value.toString()
		if (accuracy === 0 && str.includes("."))
		{
			return false
		}

		const decimal = str.split(".")[1]

		if (decimal && decimal.length > accuracy)
		{
			return false
		}
	}

	if(gte !== undefined || gt !== undefined || lt !== undefined || lte !== undefined)
	{
		const _value = Number(value)

		if (
			gte !== undefined && !(gte <= _value)
			|| gt !== undefined && !(gt < _value)
			|| lt !== undefined && !(lt > _value)
			|| lte !== undefined && !(lte >= _value)
		)
		{
			return false
		}
	}

	if (lte !== undefined && lte === Number(value) && value.toString().includes("."))
	{
		return false
	}

	return true
}

function spliceStr(str, index, add) {
	if (index < 0) {
		index = str.length + index;
		if (index < 0) {
			index = 0;
		}
	}
  
	return str.slice(0, index) + (add || "") + str.slice(index);
}

function roundToStr(value, accuracy = 0)
{
	if (
		!(value === null || value === "" || isNaN(value))
		&& check_number({ value : accuracy })
		&& value != 0
	)
	{
		const str = value.toString().split(".")

		if (!str[1] || str[1].length <= accuracy)
		{
			return value
		}
		else if (accuracy == 0)
		{
			return Math.round(Math.abs(value) + Number.EPSILON)
		}
		else
		{
			let rounded_accuracy = roundToStr(spliceStr(str[1], accuracy, ".")).toString()

			if (rounded_accuracy.length > accuracy)
			{
				const int = Number(str[0]) + 1
				return int + "." + rounded_accuracy.slice(1, accuracy+1)
			}
			else if (rounded_accuracy.length < accuracy)
			{
				while(rounded_accuracy.length < accuracy)
				{
					rounded_accuracy = "0" + rounded_accuracy
				}
			}

			return str[0] + "." + rounded_accuracy
		}
	}
	else
	{
		return value
	}

}

function round0(value)
{
	const number_value = Number(value)

	if(value == "" || value == null || Number.isNaN(number_value))
		return value

	return Math.round(number_value)
}

function round2(value)
{
	const number_value = Number(value)

	if(value == "" || value == null || Number.isNaN(number_value))
		return value

	return Math.round(number_value * 100) / 100
}

function round3(value)
{
	const number_value = Number(value)

	if(value == "" || value == null || Number.isNaN(number_value))
		return value

	return Math.round(number_value * 1000) / 1000
}

function round5(value)
{
	const number_value = Number(value)

	if(value == "" || value == null || Number.isNaN(number_value))
		return value

	return Math.round(number_value * 100000) / 100000
}

function round7(value)
{
	const number_value = Number(value)

	if(value == "" || value == null || Number.isNaN(number_value))
		return value

	return Math.round(number_value * 10000000) / 10000000
}

function get_get_query(self, key = "query")
{
	return decodeURIComponent((self.$route.query[key] + "").replace(/\+/g, "%20"))
}

function attr_key_without_attrs(attr)
{
	return attr.key.replace("attrs.", "")
}

function find_indexes(arr, fnc)
{
	var indexes = []
	
	for(var ind = 0; ind < arr.length; ind++)
		if(fnc(arr[ind]))
			indexes.push(ind)

	return indexes
}

function array_eq(arr_1, arr_2)
{
	if(arr_1 == arr_2)
		return true

	if(arr_1 == null || arr_2 == null)
		return false

	if(arr_1.length != arr_2.length)
		return false

	for(var ind = 0; ind < arr_1.length; ind++)
		if(arr_1[ind] != arr_2[ind])
			return false

  return true;
}

function kb(x_min, x_max, y_min, y_max)
{
	const x_diff = x_max - x_min
	var k
	var b

	if(x_diff == 0)
	{
		k = 0
		b = 0
	}
	else
	{
		k = ( y_max - y_min ) / x_diff
		b = y_max - k * x_max
	}

	return { k : k, b : b, eval : x => k * x + b }
}

function add_attachements_question(self, add_func, files, current_count)
{
	const threshold = 10

	if(files.length + current_count > threshold)
	{
		const h = self.$createElement
		const message = h(
			"p",
			{},
			[
				"Будет добавлено больше " + threshold + " файлов. Загрузка может занять длительное время.",
				h("br"),
				"Совет: добавьте большое количество файлов в архив.",
				h("br"),
				"Продолжить?"
			]
		)

		self.$bvModal.msgBoxConfirm(
			message,
			{
				title : "Предупреждение",
				okVariant : "danger",
				okTitle : "Продолжить",
				cancelVariant : "outline-primary-secondary",
				cancelTitle : "Отменить",
				hideHeaderClose : false,
				centered : true
			})
			.then(
				value =>
				{
					if(value)
						add_func(files)
				}
			)
	}
	else
		add_func(files)
}

function simple_alarm_question(self, question, additional = [])
{
	const h = self.$createElement
	const message = h(
		"p",
		{ "style" : "color: red" },
		[
			"Внимание! " + question,
			...additional,
			h("br"),
			h("br"),
			"ВЫ УВЕРЕНЫ?"
		]
	)

	return self.$bvModal.msgBoxConfirm(
		message,
		{
			title : "Предупреждение",
			okVariant : "danger",
			okTitle : "Продолжить",
			cancelVariant : "outline-primary-secondary",
			cancelTitle : "Отменить",
			hideHeaderClose : false,
			centered : true
		})
		.then(
			value =>
			{
				if(! value)
					throw 1
			}
		)
}

var back =
{
	go(self)
	{
		self.$root.go_back = true

		self.$router.go(-1)
	},

	check(self, clear = true)
	{
		const value = self.$root.go_back

		if(clear)
			self.$root.go_back = false

		return value
	},
}

var words =
{
	object :
	{
		accusative(count) // Винительный падеж
		{
			const mod = count % 10

			if(mod == 1)
				return "объект"
			else if(mod == 2 || mod == 3 || mod == 4)
				return "объекта"

			return "объектов"
		},

		genitive(count) // Родительный падеж
		{
			if(count == 1)
				return "объекта"
			
			return "объектов"
		}
	},

	element :
	{
		accusative(count, plural_1, plural_234, plural_others) // Винительный падеж
		{
			const mod = count % 10

			if(mod == 1)
				return plural_1
			else if(mod == 2 || mod == 3 || mod == 4)
				return plural_234

			return plural_others
		}
	}
}

var password =
{
	from_raw(raw)
	{
		return sha256(raw)
	}
}

var validation =
{
	email(email)
	{
		var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

		return re.test(email)
	}
}

var cache =
{
	paginator :
	{
		name(self, essence = null)
		{
			const postfix = ( ( essence == null ) ? self.service : essence ) + "_paginator"

			return storage.name(self, postfix)
		},

		load(self, essence = null)
		{
			return storage.get(self, cache.paginator.name(self, essence), {}, Object)
		},

		save(self, data, essence = null)
		{
			storage.set(self, cache.paginator.name(self, essence), JSON.stringify(data))
		},
	}
}

var storage =
{
	name(self, postfix)
	{
		var postfix_2 = ""

		if(self.postfix_for_storage_name)
			postfix_2 = "_" + self.postfix_for_storage_name

		return self.service + "_" + self.single_element_url + "_" + postfix + postfix_2
	},

	procedure_name(name)
	{
		const procedure_id = get_procedure()

		return name + "_" + procedure_id
	},

	local_name(self, name)
	{
		return name + "_" + storage.procedure_name(name) + "_" + self.$router.storage_prefix
	},

	set(self, name, value)
	{
		self.$localStorage.set(storage.local_name(self, name), value)
		self.$localStorage.set(storage.procedure_name(name), value)
	},

	remove(self, name)
	{
		self.$localStorage.remove(storage.local_name(self, name))
		self.$localStorage.remove(storage.procedure_name(name))
	},

	exist_local(self, name)
	{
		var value = self.$localStorage.get(storage.local_name(self, name))

		return value != null
	},

	get(self, name, default_value, type)
	{
		var value = self.$localStorage.get(storage.local_name(self, name), null, type)

		if(value == null)
			value = self.$localStorage.get(storage.procedure_name(name), default_value, type)
		
		return value
	},
}

var attrs_type_options =
[
	{ text : "Строка", value : "str" },
	{ text : "Булево", value : "bool" },
	{ text : "Число", value : "number" },
	{ text : "Дата", value : "date" },
	{ text : "Время", value : "time" },
	{ text : "Дата и время", value : "datetime" },
]

export default 
{
	is_test,
	get_session,
	get_procedure,
	has_oks,
	check_roles,
	load_roles,
	call,
	call_without_component,
	call_long_operation,
	default_error_func,
	file_url,
	open_response_url,
	download_file,
	get_file_extension,
	upload_file,
	delete_file,
	show_notification,
	show_error_box,
	get_tooltip,
	format_date,
	format_time,
	format_datetime,
	date_to_iso,
	local_date_from_iso,
	format_bool,
	format_contact_name,
	format_document_name,
	format_row_index,
	format_cost,
	format_reference,
	format_user,
	format_attr_type,
	format_key_parameter,
	format_tick_label,
	format_value,
	format_value_empty,
	format_value_from_data,
	prepare_array_of_objects_for_table,
	is_empty,
	words,
	password,
	validation,
	cache,
	attrs_type_options,
	sort_objects_array_by_key,
	sort_objects_array_by_two_keys,
	sort_objects_array_by_many_keys,
	sort_objects_array_with_key_func,
	sort_strings,
	sort_attrs_visible,
	get_obj_value,
	get_attr_value,
	format_attr_value,
	deep_clone,
	get_address_of_cadastral_object,
	format_coinvest_cost_per_unit,
	expand_node_in_tree,
	check_number,
	roundToStr,
	round0,
	round2,
	round3,
	round5,
	round7,
	number_to_string_with_ranking,
	get_get_query,
	attr_key_without_attrs,
	find_indexes,
	array_eq,
	kb,
	add_attachements_question,
	simple_alarm_question,
	storage,
	back,
}

